import { useEffect } from 'react';
import { useRouter } from 'next/router';

type Custom404Props = object;

export default function Custom404Page(_props: Custom404Props) {
  const router = useRouter();

  useEffect(() => {
    // Redirect to server-side rendered error page with original URL preserved
    // Include locale in the original path if present
    const locale = router.locale;
    const defaultLocale = router.defaultLocale;
    const asPath = router.asPath;
    
    // Construct full original path including locale prefix if it's not the default locale
    let originalPath = asPath;
    if (locale && locale !== defaultLocale && !asPath.startsWith(`/${locale}`)) {
      originalPath = `/${locale}${asPath}`;
    }
    
    const errorPageUrl = `/error/404?originalPath=${encodeURIComponent(originalPath)}`;
    router.replace(errorPageUrl);
  }, [router]);

  return null;
}

// No getStaticProps needed - this page just redirects
